import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../cn';
import {
  colSpanClasses,
  lgColSpanClasses,
  mdColSpanClasses,
  smColSpanClasses,
  threeColColSpanClasses,
  xlColSpanClasses,
  xxlColSpanClasses,
} from './gridSpanClasses';
import type { GridSpan } from './types';

export type GridItemProps = HTMLAttributes<HTMLDivElement> & {
  span?: GridSpan;
  spanSm?: GridSpan;
  spanMd?: GridSpan;
  spanLg?: GridSpan;
  spanXl?: GridSpan;
  span2xl?: GridSpan;
  /** Span at the 3col breakpoint (90rem) — three-column card grids on MacBook Pro-class widths. */
  span3col?: GridSpan;
  children: ReactNode;
};

export const GridItem = ({
  span,
  spanSm,
  spanMd,
  spanLg,
  spanXl,
  span2xl,
  span3col,
  className,
  children,
  ...props
}: GridItemProps) => (
  <div
    className={cn(
      span !== undefined && colSpanClasses[span],
      spanSm !== undefined && smColSpanClasses[spanSm],
      spanMd !== undefined && mdColSpanClasses[spanMd],
      spanLg !== undefined && lgColSpanClasses[spanLg],
      spanXl !== undefined && xlColSpanClasses[spanXl],
      span2xl !== undefined && xxlColSpanClasses[span2xl],
      span3col !== undefined && threeColColSpanClasses[span3col],
      className
    )}
    {...props}
  >
    {children}
  </div>
);
